export default __webpack_public_path__ + "static/media/magnifying-glass-primary.1427565f.svg";